<template>
  <div>
    <MonacoEditor key="prop" ref="editor" suffix="prop" :text_value='setProperties()'></MonacoEditor>
    <vs-button @click="SaveChanges"
               ref="markAsCompletedButton"
               color="success" id="btn-complete"
               class=""
               style="width:100px; float:right;">
      Save
    </vs-button>
  </div>
</template>

<script>
  import MonacoEditor from '@/views/components/extra-components/editors/MonacoEditor.vue';
  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  export default {

    data() {
       return {
        editor_content:null,
        editor:null
      };
    },
    props: ["onboarding"],
    components: {
      MonacoEditor
    },
    mounted() {
       this.setProperties();
    },
    methods: {
     

      SaveChanges() {
        var instance = this;
        const query = `
  mutation UpdateOnboarding($onboarding: OnboardingInput!) {
    updateMainFields(
      entity: $onboarding
    ) {
      id,
      name
      description
      rawContent,
      properties
    }
  }
`;
       
        instance.onboarding.properties = instance.$refs.editor.getValue()
        const variables = {
          onboarding: instance.onboarding
      };


      const req = {
        query,
        variables
      };

      TCVelikClient.PostRelative("/api/graphql", req, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      }).then(function (response) {
        if (response && response.data && response.data.data) {
          instance.onboarding.properties = response.data.data.updateMainFields.properties;
          instance.$vs.notify({
            title: "Successfully updated properties!",
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        }
        else if (response && response.data && response.data.errors) {
          alert('There were some errors saving :(');
        }
      });
      },
      setProperties() {
        try {
          var res = this.onboarding.properties;
          return res;
        }
        catch {
          return this.onboarding.properties
        }

      }
    },
    beforeDestroy() {
      // Dispose of the editor instance to clean up resources
      if (this.editor) {
        this.editor.dispose();
      }
    },
  };
</script>

<style scoped>
  .editor-wrapper {
    display: flex;
    flex-direction: column;
    height: 60vh; /* Full viewport height */
    margin: 0;
  }

  /* Ensure the editor container fills available space */
  #editor-container {
    flex-grow: 1; /* Takes up remaining space in the wrapper */
    width: 100%;
  }
</style>
